var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachmentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.571,
    height: 19.764,
    viewBox: "0 0 10.571 19.764",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "attachment_3_",
    "data-name": "attachment (3)",
    transform: "translate(-12.5 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38133",
    "data-name": "Path 38133",
    d: "M23.071,16.978V8.7a.689.689,0,0,0-1.379,0v8.273a3.907,3.907,0,1,1-7.814,0V6.407a2.528,2.528,0,0,1,5.056,0v9.882a1.149,1.149,0,1,1-2.3,0V7.326a.689.689,0,1,0-1.379,0v8.963a2.528,2.528,0,0,0,5.056,0V6.407a3.907,3.907,0,0,0-7.814,0V16.978a5.286,5.286,0,0,0,10.571,0Z",
    transform: "translate(0 0)",
    fill: "#4a5174"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentIcon);
export default __webpack_public_path__ + "static/media/attachment-icon.ca9cc51c.svg";
export { ForwardRef as ReactComponent };